<script>
import {  mapGetters } from "vuex";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CreateSetup from '../customer/list/setup'
import tableMixin from '@/helpers/mixins/table' 
import Transaction from '../customer/list/transaction'
import TechDetay from '../customer/modals/tech_detail'
import Vue from 'vue';
import { notify } from '@/helpers/notify' 

export default {
  page: {
    title: "Taşıma Listesi",
  },
  mixins: [ tableMixin ],
  components: {
    Layout,
    PageHeader,
    CreateSetup,
    Transaction,
    TechDetay,
  },
  computed: {
      ...mapGetters('authfack',['userdata'])
  },
  data() {
    return {
      title: "Taşıma Listesi",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "TAŞIMA LİSTESİ",
          active: true,
        },
      ], 
      url: "/listeler/tasima-listesi",
      techDetail:{},
      assignData: {},
      modelOpen:0,
      buttons:[
        { title:"Randevu Ver", icon:'bx bx-calendar-event', func:this.assign},
        { title:"Taşıma Detayı", icon:'check', func:this.arizaDetay},
        { title:"Tablodan Kaldır", icon:'bx bx-trash', func:this.sil},
      ],  
      columns: [
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        }, 
        {
          label: 'Kullanıcı Adı',
          field: "username",
        },
        {
          label: 'İsim Soyisim',
          field: "fullname",
        },
        {
          label: 'Cep Telefonu',
          field: this.phonenumber,
          html: true,
          sortable: false,
        },
         {
          label: 'Whatsapp',
          field: this.whatsapp,
          html: true,
          sortable: false,
        },
        {
          label: 'İl',
          field: "province",
          sortable: false,
        }, 
        {
          label: 'Bölge',
          field:  "township",
          sortable: false,
        },
        {
          label: 'Adres',
          field:  "address",
          sortable: false,
        },
        {
          label: 'Servis',
          field:  "tariff_name",
          sortable: false,
        }, 
        {
          label: 'Personel',
          field:  "user_name",
          sortable: false,
        }, 
        {
          label: 'Randevu Tarihi',
          field:  this.appointment,
          html: true,
          sortable: false,
        }, 
      ],
      data:{},
      list: {},
      transactionData:{},
    };
  },
  mounted() {
    document.getElementById('vgt-table').style.marginBottom = '150px'
  },
  methods: {

    getRandomInt() {
      return Math.floor(Math.random() * 1000);
    },

    appointment(obj){
      if(obj.appointment_at){
        if(obj.postpone){
          return  "<span class='badge rounded-pill bg-warning font-size-12'>Ertelenmiş</span> " + obj.histories[0].description;
        }
        return this.formatDate(obj.appointment_at, 'DD.MM.YYYY HH') + ':00'  
      }
      return  '-'
    },
    
    phonenumber(obj){
      const url =   obj.phonenumber;
      return `<a href=tel:'${url}'  >${obj.phonenumber}</a>`
    },

    whatsapp(obj){
      const tel = obj.phonenumber2 ? obj.phonenumber2 : (obj.phonenumber ? obj.phonenumber : '-') 
      const url =  "https://wa.me/" + tel;
      return `<a target="_blank" href='${url}'  >${tel}</a>`
    },

    arizaDetay(props){
      this.techDetail = { type:4, ...props }
      this.$parent.$bvModal.show('tech_detail')
    },

    assign(props){
      this.modelOpen = this.getRandomInt()
      this.assignData = { type:4, subs_id :props.subs_id, tech_id:props.id }
      this.$parent.$bvModal.show('setup')
    },
    
    sil(props){
      Vue.swal({
          title: "Silinecek?",
          showCancelButton: true,
          cancelButtonText: "İptal",
          confirmButtonText: "Sil"
      }).then((result) => {
          if (result.value) {
            this.$http.delete('/technic-service/ariza-sil/' + props.id)
            .then(response => {
                if(response.data.code == 100){
                  this.loadItems()
                  return notify.success(response.data.message)
                }
                return notify.error(response.data.message)
            })
          }
      });
    }

  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"  :items="items" />
    <CreateSetup  
      :data="modelOpen"
      :type="assignData.type" 
      :randevu="true"
      :subs_id="assignData.subs_id" 
      :tech_id="assignData.tech_id"
      @loadItems="loadItems" 
    />

    <Transaction 
      :transactionData="transactionData"  
      @loadItems="loadItems" 
    />

    <TechDetay 
      :data="techDetail" 
    />
    
    <vue-good-table
      mode="remote"
      styleClass="vgt-table bordered condensed"
      :line-numbers="true" 
      :total-rows="totalRecords"
      :columns="columns"
      :rows="rows"
      :pagination-options="paginationOptions"
      :is-loading.sync="isLoading"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange">
      <template slot="loadingContent">
      <div>Yükleniyor</div>
      </template>
          <template
          slot="table-row"
          slot-scope="props"
          >
          <span
              v-if="props.column.field === '#'"
              class="text-nowrap"
          >
            <b-dropdown
              class="ms-2 "
              toggle-class="font-size-16 p-0"
              toggle-tag="a"
              variant="white"
              right
            >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <template   
                v-for="(button,i) in buttons" >
                <b-dropdown-item 
                  :key="i" 
                  @click="button.func(props.row)">
                  <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
                </b-dropdown-item>
                </template>
            </b-dropdown>
          </span>
      </template>
    </vue-good-table>
  </Layout>
</template>